import React from "react";
import Button from "../../../shared/Button/Button";
import { camelToName } from "../../../../helpers/stringHelpers";

const SidebarFooter = props => {
  const { onStepChange, currentSubStepName, sceneSetting } = props;
  const isStarting = sceneSetting.currentStep === 0 && sceneSetting.currentSubStep === 0;
  const isLast = sceneSetting.currentStep === sceneSetting.stepTotal - 1;
  let disabled = !sceneSetting.editedStep.includes(currentSubStepName.replace(/\s/g, "")) || isLast;
  
  return (
    <div className="sidebar-footer">
      <div className="sidebar-button-wrapper">
        <Button disabled={isStarting} action={() => onStepChange("prev")}>Back</Button>
      </div>
      <div className="sidebar-button-wrapper">
        <Button disabled={disabled} action={() => onStepChange("next")}>
          Next
        </Button>
      </div>
    </div>
  );
};

export default SidebarFooter;
